module.exports = __webpack_public_path__ + "officialStatic/img/news2.20eda90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news2.png
// module id = 8tXV
// module chunks = 0